import { Box } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { TabValue } from '@lingoda/router';
import { topAndBottomTabsProps } from '../top-and-bottom-tabs-props';
import { LinkTab } from './LinkTab';
import type { TabCommonProps } from './types';

export const Practice = (props: TabCommonProps) => (
    <LinkTab
        {...topAndBottomTabsProps[TabValue.Practice]}
        label={<Box>{trans('navigation.user.practice', {}, 'public-common')}</Box>}
        {...props}
    />
);
